import { FC, ReactNode, memo } from 'react';
import {
  Container,
  ContentGrid,
  HeaderWrapper,
  LeftSection,
  RightSection,
} from './styled';

interface LayoutProps {
  id?: string;
  header?: ReactNode;
  leftSection?: ReactNode;
  rightSection?: ReactNode;
}

const Layout: FC<LayoutProps> = ({ id, header, leftSection, rightSection }) => (
  <Container id={id}>
    <HeaderWrapper>{header}</HeaderWrapper>
    <ContentGrid>
      <LeftSection>{leftSection}</LeftSection>
      <RightSection>{rightSection}</RightSection>
    </ContentGrid>
  </Container>
);

export default memo(Layout);
